import { Associatedapplicants } from "../Icons/Associatedapplicants";
import { Documenticon } from "../Icons/Documenticon";
import { Editing } from "../Icons/Editing";
import { HiringManagers } from "../Icons/HiringManagers";
import { Segment } from "../Icons/Segment";
import { AuditInfoInactive } from "../Icons/auditInfo-Inactive";
import { GroupUsersInactive } from "../Icons/groupUsers-Inactive";
import { Jobboardportal_black } from "../Icons/jobboardportal_black";
import { Jobportal } from "../Icons/jobportal";
import { MailInactive } from "../Icons/mail-Inactive";
import { Notesicon } from "../Icons/notesicon";
import { Portal } from "../Icons/portal";
import { Settings } from "../Icons/settings";
import { Userinactive } from "../Icons/userinactive";
import { ProjectJobs } from "../Icons/ProjectJobs";
import { GetUserInfo } from "../_utilities/getUserInfo";
import { ClientsOverview } from "../Icons/ClientsOverview";
import { EndClient } from "../Icons/EndClient";

export const getRequiredMenu = (menuType, storedTheme) => {
  const menus = {
    jobPostingMenus: [
      {
        id: 1,
        img: <Editing primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Editing primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Job Details",
        url: "jobpostings/view",
        urls: "jobpostings/edit",
      },
      {
        id: 2,
        img: <Documenticon primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: (
          <Documenticon primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Documents",
        url: "jobpostings/documents",
      },
      {
        id: 3,
        img: (
          <Associatedapplicants
            primaryFontColor={storedTheme?.secondaryColor}
          />
        ),
        activeImg: (
          <Associatedapplicants primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Associated Applicants",
        url: "jobpostings/associatedapplicants",
      },
      {
        id: 4,
        img: <Portal primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Portal primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Portals",
        url: "jobpostings/portals/view",
        urls: "jobpostings/portals/edit",
      },
      {
        id: 5,
        img: <Notesicon primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Notesicon primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Notes",
        url: "jobpostings/notes",
      },
      {
        id: 6,
        img: <Jobportal primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Jobportal primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Screening Questions",
        url: "jobpostings/screeningquestions",
      },
      {
        id: 7,
        img: (
          <AuditInfoInactive primaryFontColor={storedTheme?.secondaryColor} />
        ),
        activeImg: (
          <AuditInfoInactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Audit Info",
        url: "jobpostings/auditinfo",
      },
    ],
    applicantsMenus: [
      {
        id: 1,
        img: <Editing primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Editing primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Applicant Details",
        url: "applicants/view",
        urls: "applicants/edit",
      },
      {
        id: 2,
        img: <Documenticon primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: (
          <Documenticon primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Documents",
        url: "applicants/documents",
      },
      {
        id: 3,
        img: (
          <Associatedapplicants
            primaryFontColor={storedTheme?.secondaryColor}
          />
        ),
        activeImg: (
          <Associatedapplicants primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Associated Jobs",
        url: "applicants/associatedjobs",
      },
      {
        id: 4,
        img: <Notesicon primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Notesicon primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Notes",
        url: "applicants/notes",
      },
      {
        id: 5,
        img: (
          <AuditInfoInactive primaryFontColor={storedTheme?.secondaryColor} />
        ),
        activeImg: (
          <AuditInfoInactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Audit Info",
        url: "applicants/auditinfo",
      },
    ],
    clientsMenus: [
      {
        id: 1,
        img: <ClientsOverview primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: (
          <ClientsOverview primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Overview",
        url: "clients/view",
        // urls: "clients/edit",
      },
      {
        id: 2,
        img: <HiringManagers primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: (
          <HiringManagers primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Hiring Managers",
        url: "clients/hiringmanagers",
      },
      {
        id: 3,
        img: <EndClient primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <EndClient primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "End Clients",
        url: "clients/endclient",
      },
      {
        id: 4,
        img: <ProjectJobs primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <ProjectJobs primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Jobs",
        url: "clients/jobs",
      },
      {
        id: 5,
        img: (
          <AuditInfoInactive primaryFontColor={storedTheme?.secondaryColor} />
        ),
        activeImg: (
          <AuditInfoInactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Audit Info",
        url: "clients/auditinfo",
      },
    ],
    helpSectionMenus: [
      {
        id: 1,
        img: <Editing primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Editing primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Job Postings",
        url: "helpsection/postings",
        urls: "helpsection/postings",
      },
      {
        id: 2,
        img: <Notesicon primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Notesicon primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Applicants",
        url: "helpsection/applicant",
      },
      {
        id: 3,
        img: <Documenticon primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: (
          <Documenticon primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "E-mail Templates",
        url: "helpsection/emailtemplates",
      },
    ],
    customerMenus: [
      {
        id: 1,
        img: <Userinactive primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: (
          <Userinactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Customer Details",
        url: "customer/view",
        // urls: "customers/edit",
      },
      {
        id: 2,
        img: <Settings primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Settings primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Billing",
        url: "customer/billing",
      },
      {
        id: 3,
        img: (
          <GroupUsersInactive primaryFontColor={storedTheme?.secondaryColor} />
        ),
        activeImg: (
          <GroupUsersInactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Users",
        url: "customer/users",
      },
      {
        id: 4,
        img: (
          <GroupUsersInactive primaryFontColor={storedTheme?.secondaryColor} />
        ),
        activeImg: (
          <GroupUsersInactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Vendors",
        url: "customer/vendors",
      },
      {
        id: 5,
        img: <Settings primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Settings primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Custom",
        url: "customer/custom",
      },
      {
        id: 6,
        img: <Segment primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Segment primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Segments",
        url: "customer/segments",
      },
      {
        id: 7,
        img: (
          <Jobboardportal_black
            primaryFontColor={storedTheme?.secondaryColor}
          />
        ),
        activeImg: (
          <Jobboardportal_black primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Jobboard Portal",
        url: "customer/jobboardportal",
        // urls: "customer/jobboardportal/edit",
      },

      {
        id: 8,
        img: <MailInactive primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: (
          <MailInactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "E-mail",
        url: "customer/organize/mail",
        // urls: "customers/jobboardportal/edit",
      },
    ],
    managerMenus: [
      {
        id: 1,
        img: <Userinactive primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: (
          <Userinactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Customer Details",
        url: "customer/view",
        // urls: "customers/edit",
      },
      {
        id: 2,
        img: <Settings primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Settings primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Custom",
        url: "customer/custom",
      },
      {
        id: 3,
        img: <MailInactive primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: (
          <MailInactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "E-mail",
        url: "customer/organize/mail",
        // urls: "customers/jobboardportal/edit",
      },
    ],
    projectsMenus: [
      {
        id: 1,
        img: <Editing primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <Editing primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Project Details",
        url: "projects/view",
        urls: "projects/edit",
      },
      {
        id: 2,
        img: <ProjectJobs primaryFontColor={storedTheme?.secondaryColor} />,
        activeImg: <ProjectJobs primaryFontColor={storedTheme?.primaryColor} />,
        menuName: "Jobs",
        url: "projects/jobs",
      },
      {
        id: 3,
        img: (
          <Associatedapplicants
            primaryFontColor={storedTheme?.secondaryColor}
          />
        ),
        activeImg: (
          <Associatedapplicants primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Applicants",
        url: "projects/applicant",
      },
      {
        id: 4,
        img: (
          <AuditInfoInactive primaryFontColor={storedTheme?.secondaryColor} />
        ),
        activeImg: (
          <AuditInfoInactive primaryFontColor={storedTheme?.primaryColor} />
        ),
        menuName: "Audit Info",
        url: "projects/auditinfo",
      },
    ],
    BreadCrumbData: [
      {
        id: 1,
        name: "View",
        url: "jobpostings/view",
        icon: "editingIcon",
        type: "jobpostings",
      },
      {
        id: 2,
        name: "Edit",
        url: "jobpostings/edit",
        icon: "editingIcon",
        type: "jobpostings",
      },
      {
        id: 3,
        name: "Documents",
        url: "jobpostings/documents",
        icon: "documentIcon",
        type: "jobpostings",
      },
      {
        id: 4,
        name: "Associated Applicants",
        url: "jobpostings/associatedapplicants",
        icon: "associatedApplicantsIcon",
        type: "jobpostings",
      },
      {
        id: 5,
        name: "Notes",
        url: "jobpostings/notes",
        icon: "notesIcon",
        type: "jobpostings",
      },
      {
        id: 6,
        name: "Screening Questions",
        url: "jobpostings/screeningquestions",
        icon: "screenQuestionsIcon",
        type: "jobpostings",
      },
      {
        id: 7,
        name: "Audit Info",
        url: "jobpostings/auditinfo",
        icon: "auditIcon",
        type: "jobpostings",
      },

      // applicants
      {
        id: 8,
        name: "View",
        url: "applicants/view",
        icon: "editingIcon",
        type: "applicants",
      },
      {
        id: 9,
        name: "Edit",
        url: "applicants/edit",
        icon: "editingIcon",
        type: "applicants",
      },
      {
        id: 10,
        name: "Documents",
        url: "applicants/documents",
        icon: "documentIcon",
        type: "applicants",
      },
      {
        id: 11,
        name: "Associated Jobs",
        url: "applicants/associatedjobs",
        icon: "associatedApplicantsIcon",
        type: "applicants",
      },
      {
        id: 12,
        name: "Notes",
        url: "applicants/notes",
        icon: "notesIcon",
        type: "applicants",
      },
      {
        id: 13,
        name: "Audit Info",
        url: "applicants/auditinfo",
        icon: "auditIcon",
        type: "applicants",
      },
      // clients
      {
        id: 14,
        name: "Overview",
        url: "clients/view",
        icon: "Clients",
        type: "clients",
      },
      {
        id: 15,
        name: "Edit",
        url: "clients/edit",
        icon: "Clients",
        type: "clients",
      },
      {
        id: 16,
        name: "End Clients",
        url: "clients/endclient",
        icon: "Clients",
        type: "clients",
      },
      {
        id: 17,
        name: "Hiring Managers",
        url: "clients/hiringmanagers",
        icon: "Clients",
        type: "clients",
      },
      {
        id: 18,
        name: "Jobs",
        url: "clients/jobs",
        icon: "Clients",
        type: "clients",
      },
      {
        id: 19,
        name: "Audit Info",
        url: "clients/auditinfo",
        icon: "auditIcon",
        type: "clients",
      },
      // jobpostingsportals
      {
        id: 20,
        name: "Portals View",
        url: "jobpostings/portals/view",
        icon: "portalIcon",
        type: "jobpostings",
      },
      {
        id: 21,
        name: "Portals Edit",
        url: "jobpostings/portals/edit",
        icon: "portalIcon",
        type: "jobpostings",
      },
      // helpsection

      // {
      //   id: 19,
      //   name: "Portals Edit",
      //   url: "postings/portals/edit",
      //   icon: `${process.env.PUBLIC_URL}/assests/img/personicon.svg`,
      //   type: "helpsection"
      // },
      // {
      //   id: 20,
      //   name: "Portals Edit",
      //   url: "postings/portals/edit",
      //   icon: `${process.env.PUBLIC_URL}/assests/img/personicon.svg`,
      //   type: "helpsection"
      // },
      // {
      //   id: 21,
      //   name: "Portals Edit",
      //   url: "postings/portals/edit",
      //   icon: `${process.env.PUBLIC_URL}/assests/img/personicon.svg`,
      //   type: "helpsection"
      // },

      //customer
      {
        id: 22,
        name: "View",
        url: "customer/view",
        icon: "customerIcon",
        type: "customer",
      },
      {
        id: 23,
        name: "Users",
        url: "customer/users",
        icon: "groupIcon",
        type: "customer",
      },
      {
        id: 24,
        name: "Vendors",
        url: "customer/vendors",
        icon: "groupIcon",
        type: "customer",
      },
      {
        id: 25,
        name: "Custom",
        url: "customer/custom",
        icon: "CustomIcon",
        type: "customer",
      },
      {
        id: 26,
        name: "Jobboard Portal",
        url: "customer/jobboardportal",
        icon: "jobportalIcon",
        type: "customer",
      },
      // {
      //   id: 24,
      //   name: "Jobboard Portal Edit",
      //   url: "customer/jobboardportal/edit",
      //   icon: "jobportalIcon",
      //   type: "customer"
      // },
      {
        id: 27,
        name: "E-mail",
        url: "customer/organize/mail",
        icon: "mailIcon",
        type: "customer",
      },
      {
        id: 28,
        name: "Segments",
        url: "customer/segments",
        icon: "segmentsIcon",
        type: "customer",
      },
      //customer

      // projects
      {
        id: 29,
        name: "View",
        url: "projects/view",
        icon: "editingIcon",
        type: "projects",
      },
      {
        id: 30,
        name: "Edit",
        url: "projects/edit",
        icon: "editingIcon",
        type: "projects",
      },
      {
        id: 31,
        name: "Jobs",
        url: "projects/jobs",
        icon: "ProjectJobs",
        type: "projects",
      },

      {
        id: 32,
        name: "Applicants",
        url: "projects/applicant",
        icon: "associatedApplicantsIcon",
        type: "projects",
      },

      {
        id: 33,
        name: "Audit Info",
        url: "projects/auditinfo",
        icon: "auditIcon",
        type: "projects",
      },
      // customer
      {
        id: 34,
        name: "Billing",
        url: "customer/billing",
        icon: "CustomIcon",
        type: "customer",
      },
    ],
    BreadCrumbObj: [
      {
        id: 1,
        name: "Job Postings",
        url: "jobpostings/landing",
        icon: "",
        type: "",
      },
      {
        id: 2,
        name: "Applicants",
        url: "applicants/landing",
        icon: "",
        type: "",
      },
      {
        id: 3,
        name: "Clients",
        url: "clients/landing",
        icon: "",
        type: "",
      },
      {
        id: 4,
        name: "HelpSection",
        url: "helpsection/postings",
        icon: "",
        type: "",
      },
      {
        id: 5,
        name: "customer",
        url: "customer/view",
        icon: "",
        type: "",
      },
      {
        id: 6,
        name: "Projects",
        url: "projects/landing",
        icon: "",
        type: "",
      },
    ],
  };

  // Get user role for role-based menu filtering
  const getUserRole = async () => {
    try {
      const userInfo = await GetUserInfo();
      return userInfo ? userInfo.systemroles : null;
    } catch (error) {
      console.error("Error getting user role:", error);
      return null;
    }
  };

  const userRole = getUserRole();
  let filteredMenus = menus[menuType] || [];

  // Filter out billing menu for non-admin users
  if (menuType === "customerMenus" && userRole) {
    const allowedRoles = ["Admin", "Super Admin"];
    if (!allowedRoles.includes(userRole)) {
      filteredMenus = filteredMenus.filter(
        (menu) => menu.menuName !== "Billing",
      );
    }
  }

  return filteredMenus;
};
